export default __webpack_public_path__ + "static/media/views.682497ec.svg";